import { Element } from '@/components/core';
import { UIComponent } from '@/components/core/components';
import clsx from 'clsx';
import * as styles from './subtitle.styles';

const Subtitle: UIComponent = ({ className, children, ...props }) => {
  return (
    <Element as="h2" className={clsx(styles.root, className)} {...props}>
      {children}
    </Element>
  );
};

export default Subtitle;
